import User from '../../../base/errors/user';
import create from './Create';

const user: User = {
  create,
  notificationChannelUnableToLoad: 'Notification channel could not be loaded'
};

export default user;
